import { useCallback, useEffect, useState } from "react";
import { Marker, Pane, Tooltip } from "react-leaflet";
import L, { MarkerCluster, divIcon, icon } from "leaflet";
import { useAppSelector } from "Hooks/useRedux";
import useSurveys from "Hooks/useSurveys";
import MarkerClusterGroup from "react-leaflet-cluster";
import SourceSvg from "Assets/Images/Survey/source-icon.svg";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import useTraffic from "Hooks/useTraffic";
import { Box, Card, Stack, Typography } from "@mui/material";
import useMarginPark from "Hooks/useMarginPark";
import Icon from "Components/Icon";
import { renderToStaticMarkup } from "react-dom/server";

const ICON_SIZE = 22;

const sourceIconIcon = icon({ iconUrl: SourceSvg, iconSize: [ICON_SIZE, ICON_SIZE] });

export default function MarginParkMarkerCluster() {
  const { zone } = useAppSelector((state) => state.zones);
  const { visible } = useAppSelector((state) => state.marginPark);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useMarginPark();
  const [radius, setRadius] = useState<number>(50);

  const handleSourcesMarker = (marginParks: any) => {
    return marginParks?.map((item: any, indx: number) => {
      if (!item.Park) return;
      const marginPark = JSON.parse(`{${item.Park}}`);

      const marginParkIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${21 + (marginPark.Number + 1) / 12}px`,
            height: `${21 + (marginPark.Number + 1) / 12}px`,
            backgroundColor: "#fffd",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#62b362cc",
            display: "grid",
            placeItems: "center",
            color: "#666",
          }}
        >
          <Icon icon="local_parking" sx={{ color: "red" }} />
        </Box>
      );

      const marginParkIcon = divIcon({
        html: marginParkIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
        className: item.Status === 1 ? "green-color" : "red-color",
      });

      //   const tooltipContent = (
      //     <Tooltip direction="top" offset={[0, -20]}>
      //       <Card sx={{ py: 2, px: 3 }}>
      //         <Stack alignItems="center">
      //           <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
      //             <Typography> {traffic.DeviceName} </Typography>
      //             <Typography> : نام سامانه </Typography>
      //           </Stack>
      //           <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
      //             {" "}
      //             <Typography> {traffic.TTO}</Typography>
      //             <Typography> : تعداد</Typography>
      //           </Stack>
      //           <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
      //             <Typography>{traffic.MethodName}</Typography>
      //             <Typography> : نوع سامانه</Typography>
      //           </Stack>
      //           <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
      //             <Typography>{traffic?.DeviceCode}</Typography>
      //             <Typography> : کد سامانه</Typography>
      //           </Stack>
      //         </Stack>
      //       </Card>
      //     </Tooltip>
      //   );
      return <Marker position={[marginPark.Lat, marginPark.Long]} icon={marginParkIcon} />;
    });
  };

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return L.divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: L.point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      {" "}
      <Pane name={`${Math.random()}show_marginPark_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <MarkerClusterGroup chunkedLoading maxClusterRadius={radius} iconCreateFunction={createSourceCustomIcon}>
          {handleSourcesMarker(data)}
        </MarkerClusterGroup>
      </Pane>
    </>
  );
}
